import { render, staticRenderFns } from "./TrackFeedbackNum.vue?vue&type=template&id=5bcbfd36"
import script from "./TrackFeedbackNum.vue?vue&type=script&lang=js"
export * from "./TrackFeedbackNum.vue?vue&type=script&lang=js"
import style0 from "./TrackFeedbackNum.vue?vue&type=style&index=0&id=5bcbfd36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports